export default __webpack_public_path__ + "static/media/Viaduct-Preserve-01.0201b5d8.jpg";